// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"d15d6cde","787":"906fe389"}[chunkId] + ".chunk.js";
};